module.exports = __webpack_public_path__ + "static/media/Screenshot5.a6fcf2ff.png";